import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { connect, useSelector, useDispatch } from 'react-redux'

import { Modal } from 'common-components/index'
import { setAppValue } from '../../../apps/actions'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { clearEkycResults, enterEkycF2f } from 'core/actions'
import { isForeigner } from 'e-submission/domain/data-model/form/selectors'
import { use, useState } from 'react'
import { select } from 'redux-saga/effects'

const EkycPreviewInfo = (props) => {
  const app = useSelector((state) => getCurrentApp(state))
  const dispatch = useDispatch()

  const { isOpen, onExit, handlerCreateCaseEkyc, insuredOrPayer } = props

  const firstName = _.get(app, `${props.insuredOrPayer}.firstName`, 'xxx')
  const lastName = _.get(app, `${props.insuredOrPayer}.lastName`, 'xxx')
  const citizenId = _.get(app, `${props.insuredOrPayer}.idNo.citizenId`, 'xxx')
  const passport = _.get(app, `${props.insuredOrPayer}.idNo.passport`, 'xxx')
  const foreigner = isForeigner(app, props.insuredOrPayer)
  const [isSkipEkyc, setIsSkipEkyc] = useState(false)

  const onClearEkycResults = () => {
    dispatch(clearEkycResults(props.insuredOrPayer))
  }

  const confirmCreateEkyc = () => {
    dispatch(enterEkycF2f(props.insuredOrPayer))
  }

  return (
    <Modal
      className={'insured-and-payer-details-confirmations-modal'}
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
    >
      <ModalHeader className={'header-modal'}>
        กรุณายืนยันเพื่อเข้าสู่ขั้นตอนการยืนยันตัวตน
        <Button
          className="close"
          onClick={onExit}
          type="button"
          style={{ fontSize: '1.5rem', position: 'absolute', right: '15px', top: '5px' }}
        >
          &times;
        </Button>
      </ModalHeader>
      <ModalBody>
        <div className={'flex-container'} style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ textAlign: 'right', paddingRight: '5px' }}>
            ชื่อ:
            <br />
            นามสกุล:
            <br />
            {foreigner ? 'หนังสือเดินทาง:' : 'เลขประจำตัวประชาชน:'}
          </div>
          <div style={{ textAlign: 'left', paddingLeft: '5px' }}>
            {firstName}
            <br />
            {lastName}
            <br />
            {foreigner ? passport : citizenId}
          </div>
        </div>
        <div className={'normal-text detail-text modal-title'} style={{ color: '#2425aa' }}>
          โปรดตรวจสอบความถูกต้องอีกครั้งก่อนกดยืนยัน
        </div>
        <div className={'normal-text'}>
          <Link to={insuredOrPayer === 'insured' ? 'insured' : 'owner'}>
            <Button
              className="back-button"
              onClick={() => {
                onClearEkycResults()
              }}
            >
              แก้ไข
            </Button>
          </Link>
          <Button
            color={'primary'}
            onClick={() => {
              confirmCreateEkyc()
              onExit()
              // require passport to be exactly 13 numeric digits
              if (foreigner && /^\d{13}$/.test(passport) && !_.isEmpty(passport)) {
                console.log(
                  'insured/payer has nationality not aqua "Thai" and passport with numeric 13 digits like 1111111111119'
                )
              } else {
                handlerCreateCaseEkyc()
              }
            }}
            className="primary"
          >
            ยืนยัน
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

const mapStateToEkycPreviewInfoModal = (state, props) => {
  const app = getCurrentApp(state)
  const firstName = _.get(app, `${props.insuredOrPayer}.firstName`, 'xxx')
  const lastName = _.get(app, `${props.insuredOrPayer}.lastName`, 'xxx')
  const citizenId = _.get(app, `${props.insuredOrPayer}.idNo.citizenId`, 'xxx')
  const passport = _.get(app, `${props.insuredOrPayer}.idNo.passport`, 'xxx')
  const foreigner = isForeigner(app, props.insuredOrPayer)
  return {
    firstName,
    lastName,
    citizenId,
    foreigner,
    passport,
  }
}

export default EkycPreviewInfo
